import React from 'react';
export var CvvIconV3 = _ref => {
  var {
    ariaDescribedByContent,
    ariaDescribedById
  } = _ref;
  return React.createElement("svg", {
    fill: "none",
    height: "18",
    viewBox: "0 0 56 34",
    width: "29",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("title", {
    id: ariaDescribedById
  }, ariaDescribedByContent), React.createElement("g", {
    clipPath: "url(#clip0_15183_27124)"
  }, React.createElement("path", {
    d: "M0 2.89419C0 1.29577 1.28942 0 2.88 0H53.12C54.7106 0 56 1.29577 56 2.89419V31.1058C56 32.7042 54.7106 34 53.12 34H2.88C1.28942 34 0 32.7042 0 31.1058V2.89419Z",
    fill: "#003087"
  }), React.createElement("rect", {
    fill: "#56CCFE",
    height: "7",
    width: "56",
    y: "7"
  }), React.createElement("path", {
    clipRule: "evenodd",
    d: "M50 20.96H40C39.4256 20.96 38.96 21.4256 38.96 22V28C38.96 28.5744 39.4256 29.04 40 29.04H50C50.5744 29.04 51.04 28.5744 51.04 28V22C51.04 21.4256 50.5744 20.96 50 20.96ZM40 20C38.8954 20 38 20.8954 38 22V28C38 29.1046 38.8954 30 40 30H50C51.1046 30 52 29.1046 52 28V22C52 20.8954 51.1046 20 50 20H40Z",
    fill: "#00CF92",
    fillRule: "evenodd"
  }), React.createElement("path", {
    d: "M41 24.5C41 24.2239 41.2239 24 41.5 24H42.5C42.7761 24 43 24.2239 43 24.5V25.5C43 25.7761 42.7761 26 42.5 26H41.5C41.2239 26 41 25.7761 41 25.5V24.5Z",
    fill: "#EDEDED"
  }), React.createElement("path", {
    d: "M44 24.5C44 24.2239 44.2239 24 44.5 24H45.5C45.7761 24 46 24.2239 46 24.5V25.5C46 25.7761 45.7761 26 45.5 26H44.5C44.2239 26 44 25.7761 44 25.5V24.5Z",
    fill: "#EDEDED"
  }), React.createElement("path", {
    d: "M47 24.5C47 24.2239 47.2239 24 47.5 24H48.5C48.7761 24 49 24.2239 49 24.5V25.5C49 25.7761 48.7761 26 48.5 26H47.5C47.2239 26 47 25.7761 47 25.5V24.5Z",
    fill: "#EDEDED"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "clip0_15183_27124"
  }, React.createElement("rect", {
    fill: "white",
    height: "34",
    width: "56"
  }))));
};